import { createContext, useContext } from "react";
import apiService, { getBaseURL } from "../services/api";
import useApiData from "../hooks/useApiData";
import { FALLBACK_MENU } from "../constants/menuConstants";

/**
 * Context for managing navigation menu structure
 * Provides menu items with nested sub-items and logo data with fallback menu
 */
const MenuContext = createContext();

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error("useMenu must be used within a MenuProvider");
  }
  return context;
};

export const MenuProvider = ({ children }) => {
  const {
    data: menuData,
    loading,
    error,
    refetch,
  } = useApiData(() => apiService.getMenu(), [], {
    fallback: FALLBACK_MENU,
    unwrapStrapi: true,
    resourceName: "menu",
  });

  // Helper function to get logo URL
  const getLogoUrl = () => {
    if (menuData?.logo?.url) {
      const logoUrl = menuData.logo.url;
      // If the URL is relative, use Strapi's base URL
      if (logoUrl.startsWith("/")) {
        const strapiBaseUrl = getBaseURL();
        return strapiBaseUrl + logoUrl;
      }
      return logoUrl;
    }
    return null;
  };

  const value = {
    menuData,
    loading,
    error,
    getLogoUrl,
    refetch,
  };

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

export default MenuContext;
